import { useEffect, useMemo, useRef } from "react";
import {
  applyCopyFieldRules,
  collectRules,
  ruleDependencyKey
} from "./formRules";

export default function useFormCopyRules(formDefinition, formValues, setFormValues) {
  const rules = useMemo(
    () => collectRules(formDefinition?.details, "COPY_FIELDS"),
    [formDefinition?.details]
  );
  const previousMatches = useRef({});
  const formIdentity = `${formDefinition?.form?.sFormName || ""}:${
    formDefinition?.form?.sFormAction || ""
  }`;
  const dependencyKey = ruleDependencyKey(rules, formValues);

  useEffect(() => {
    previousMatches.current = {};
  }, [formIdentity]);

  useEffect(() => {
    if (!rules.length || typeof setFormValues !== "function") return;

    const priorMatches = previousMatches.current;
    const result = applyCopyFieldRules(formValues || {}, rules, priorMatches);
    previousMatches.current = result.matches;

    if (result.values === formValues) return;

    setFormValues(currentValues =>
      currentValues === formValues
        ? result.values
        : applyCopyFieldRules(currentValues || {}, rules, priorMatches).values
    );
  }, [dependencyKey, rules, setFormValues]);
}
